module.exports = __webpack_public_path__ + "static/img/icon44.b86e50f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon44.png
// module id = R/f8
// module chunks = 1